import { AngularFireAuthGuard, redirectUnauthorizedTo } from '@angular/fire/compat/auth-guard';
import { RouterModule, Routes } from '@angular/router';
import { ScopeGuard } from '@app/shared/guards/scope.guard';
import { AdminScopes } from '@app/shared/services/user.service';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '@app/shared/components/components.module';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { SiteToursComponent } from '@app/pages/authenticated/pages/site-tours/site-tours.component';
import {
  EditToursComponent
} from '@app/pages/authenticated/pages/site-tours/components/edit-tours/edit-tours.component';
import {
  ListSiteToursComponent
} from '@app/pages/authenticated/pages/site-tours/components/list-site-tours/list-site-tours.component';
import {
  ListHotspotsComponent
} from '@app/pages/authenticated/pages/site-tours/components/list-hotspots/list-hotspots.component';
import {
  EditHotspotsComponent
} from '@app/pages/authenticated/pages/site-tours/components/edit-hotspots/edit-hotspots.component';
import { IconDropdownComponent } from '@app/pages/authenticated/components/icon-dropdown/icon-dropdown.component';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['login']);
const routes: Routes = [
  {
    path: '',
    canActivate: [AngularFireAuthGuard, ScopeGuard],
    data: { scopes: [AdminScopes.VIEW_SITE_TOURS] },
    canActivateChild:[ScopeGuard],
    children: [
      { path: '', component: SiteToursComponent, data: { scopes: [AdminScopes.VIEW_SITE_TOURS], authGuardPipe: redirectUnauthorizedToLogin }}
    ]
  }
];

@NgModule({
  imports: [
    ComponentsModule,
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    IconDropdownComponent,
  ],
  exports: [RouterModule],
  declarations: [
    SiteToursComponent,
    EditToursComponent,
    EditHotspotsComponent,
    ListHotspotsComponent,
    ListSiteToursComponent,
  ]
})
export class SiteToursModule { }
